import { useMutation } from 'react-query';
import {
  useDataProvider,
  useNotify,
  useRefresh,
  useUnselectAll,
} from 'react-admin';

const useCustomRpc = ({
  httpMethod,
  path,
  successMessage,
  errorMessage,
  shouldRefresh,
  shouldUnselectAll,
  mimeType,
  ...queryOptions
}) => {
  const dataProvider = useDataProvider();
  const refresh = useRefresh();
  const unselectAll = useUnselectAll(shouldUnselectAll);
  const notify = useNotify();
  const mutation = useMutation(async (data) => {
    let body = data;
    let overridePath;
    if (!Array.isArray(data)) {
      const { overridePath: pathOverride, ...rest } = data ?? {};
      overridePath = pathOverride;
      body = rest;
    } else {
      body = data;
    }
    return dataProvider.customRpc({
      httpMethod,
      path: overridePath ?? path,
      data: httpMethod !== 'GET' ? body : undefined,
      mimeType: mimeType ?? 'json',
    });
  }, {
    ...queryOptions,
    onSuccess: async (...args) => {
      if (successMessage) notify(successMessage, { type: 'info' });
      if (shouldRefresh) refresh();
      if (shouldUnselectAll) unselectAll();
      if (queryOptions.onSuccess) return queryOptions.onSuccess(...args);
      return undefined;
    },
    onError: async (e, ...args) => {
      const notificationMessage = `${errorMessage}. Reason: ${e?.message}`;
      if (notificationMessage) notify(notificationMessage, { type: 'error', autoHideDuration: 10000 });
      if (queryOptions.onError) return queryOptions.onError(e, ...args);
      return undefined;
    },
  });

  return mutation;
};

export default useCustomRpc;
